import React, { FC } from 'react'
import { FaXmark } from 'react-icons/fa6'

import { SpaceBookingPanel, SpaceBookingParams } from 'features/space/components/SpaceBookingPanel'
import type { Space } from 'features/space/types/spaceDetail'

import styles from './styles.module.css'

type Props = {
  space: Space
  visible: boolean
  isLoading: boolean
  onBooking: (params: SpaceBookingParams) => void
  onClose: () => void
}

/**
 * /spaces/[uuid] のモバイル用予約オーバーレイ (components/Pages/Pudo/SpaceSpBooking 相当)。
 */
export const SpaceSpBookingOverlay: FC<Props> = ({
  space,
  visible,
  isLoading,
  onBooking,
  onClose,
}) => {
  if (!visible) return null

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <button onClick={onClose} className={styles.closeButton}>
          <FaXmark size={32} color="#333" />
        </button>
        <SpaceBookingPanel isLoading={isLoading} onBooking={onBooking} space={space} />
      </div>
    </div>
  )
}
